import apiClient from './client';

export const createCharacter = () => apiClient.post('/characters');

export const listCharacters = () => apiClient.get('/characters', {
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
});

export const fetchCharacter = (id) => apiClient.get(`/characters/${id}`, {
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
  params: {
    _: Date.now(),
  },
});

export const uploadCharacterImages = (id, files = [], options = {}) => {
  const formData = new FormData();
  files.forEach((file) => {
    if (file) {
      formData.append('images', file);
    }
  });

  return apiClient.post(`/characters/${id}/images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: options.onUploadProgress,
  });
};

export const prepareCharacter = (id) =>
  apiClient.post(`/characters/${id}/prepare`, null, {
    timeout: 300000,
  });

export const deleteCharacter = (id) => apiClient.delete(`/characters/${id}`);

export default {
  createCharacter,
  listCharacters,
  fetchCharacter,
  uploadCharacterImages,
  prepareCharacter,
  deleteCharacter,
};
